import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InicioComponent } from './modules/inicio/inicio.component';
import { SidenavComponent } from './shared/sidenav/sidenav.component';

const routes: Routes = [
  {
    path: '',
    component: SidenavComponent,
    children: [
      {
        path: 'inicio',
        component: InicioComponent,
      },
      {
        path: 'pedidos',
        loadChildren: () =>
          import('./modules/pedidos/pedidos.module').then(
            (m) => m.PedidosModule
          ),
      },
      {
        path: 'parametros',
        loadChildren: () =>
          import('./modules/parametros/parametros.module').then(
            (m) => m.ParametrosModule
          ),
      },
      {
        path: 'productos',
        loadChildren: () =>
          import('./modules/productos/productos.module').then(
            (m) => m.ProductosModule
          ),
      },
      {
        path: 'calendario',
        loadChildren: () =>
          import('./modules/calendario/calendario.module').then(
            (m) => m.CalendarioModule
          ),
      },
      {
        path: '',
        redirectTo: 'inicio',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BackofficeRoutingModule {}
